import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { useConfig } from "@/hooks/useConfig";
import { telHref } from "@/lib/format";

const WaIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35M12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.4 9.4 0 0 1-1.44-5.02c0-5.2 4.23-9.43 9.44-9.43a9.38 9.38 0 0 1 9.43 9.44c0 5.2-4.24 9.43-9.44 9.43m8.02-17.46A11.27 11.27 0 0 0 12.05.72C5.8.72.7 5.8.7 12.06c0 2 .52 3.95 1.52 5.67L.6 23.6l6.02-1.58a11.3 11.3 0 0 0 5.42 1.38h.01c6.25 0 11.34-5.09 11.35-11.34 0-3.03-1.18-5.88-3.33-8.02" />
  </svg>
);

export default function FloatingContact() {
  const cfg = useConfig();
  const { pathname } = useLocation();
  const onBook = pathname === "/book";
  const msg = encodeURIComponent("Hello Ananta Hotels, I would like to enquire about a booking.");
  return (
    <div className={`no-print fixed right-3 sm:right-4 z-40 flex-col gap-2 sm:gap-3 ${onBook ? "hidden lg:flex bottom-5" : "flex bottom-4 sm:bottom-5"}`}>
      <a href={telHref(cfg.contact_phone)} aria-label="Call us" data-testid="floating-call-btn"
        className="h-11 w-11 sm:h-12 sm:w-12 rounded-full bg-[#1E3B2E] text-[#FDFBF7] flex items-center justify-center shadow-lg transition-transform duration-300 hover:scale-105">
        <Phone size={20} />
      </a>
      <a href={`https://wa.me/${cfg.whatsapp}?text=${msg}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp us" data-testid="floating-whatsapp-btn"
        className="h-12 w-12 sm:h-14 sm:w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg transition-transform duration-300 hover:scale-105">
        <WaIcon />
      </a>
    </div>
  );
}
